export interface OnboardingState {
  readonly keyRingConfigured: boolean
  readonly apiKeyGenerated: boolean
  readonly hostRegistered: boolean
}

export interface UserInitializationResponse {
  readonly onboarding: OnboardingState
}

export type UserInitializationError =
  | {
      readonly type: 'NO_ACCESS_TOKEN'
      readonly message: 'No access token available'
    }
  | {
      readonly type: 'MAX_ATTEMPTS_REACHED'
      readonly message: string
      readonly attempts: number
    }
  | {
      readonly type: 'HTTP_ERROR'
      readonly message: string
      readonly status: number
    }
  | {
      readonly type: 'NETWORK_ERROR'
      readonly message: string
      readonly cause?: string
    }

export const createUserInitializationError = {
  noAccessToken: (): UserInitializationError => ({
    type: 'NO_ACCESS_TOKEN',
    message: 'No access token available',
  }),
  maxAttemptsReached: (attempts: number): UserInitializationError => ({
    type: 'MAX_ATTEMPTS_REACHED',
    message: `User initialization failed after ${attempts} attempts`,
    attempts,
  }),
  httpError: (status: number): UserInitializationError => ({
    type: 'HTTP_ERROR',
    message: `User initialization failed with status ${status}`,
    status,
  }),
  networkError: (message: string, cause?: string): UserInitializationError => ({
    type: 'NETWORK_ERROR',
    message,
    ...(cause && { cause }),
  }),
} as const
